// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSingleColumn_root__3A2yW","layoutWrapperMain":"LayoutSingleColumn_layoutWrapperMain__3uWAJ"};